import React from "react";
import {
  Container,
  Grid,
  Typography,
  Link,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

// עיצוב ברור כאשר עוברים על קישור באמצעות Tab
const accessibleLinkStyle = {
  display: "inline-block",
  borderRadius: 1,
  px: 0.5,
  color: "primary.main",

  "&:hover": {
    color: "primary.main",
    textDecoration: "underline",
  },

  "&:focus-visible": {
    color: "primary.main",
    outline: "3px solid",
    outlineColor: "primary.main",
    outlineOffset: "4px",
    textDecoration: "underline",
  },
};

const titleStyle = {
  fontWeight: "bold",
  mb: 2,
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export default function Footer() {
  return (
    <Container
      maxWidth="md"
      component="footer"
      dir="rtl"
      aria-label="מידע וקישורים בתחתית האתר"
      sx={{
        borderTop: (theme) =>
          `1px solid ${theme.palette.divider}`,
        mt: 8,
        py: {
          xs: 3,
          sm: 6,
        },
        backgroundColor: (theme) =>
          theme.palette.background.paper,
        color: (theme) =>
          theme.palette.text.primary,
      }}
    >
      <Grid
        container
        spacing={4}
        justifyContent="space-evenly"
      >
        {/* פרטי העסק */}
        <Grid item xs={12} sm={3} md={3}>
          <Typography
            component="h2"
            variant="h6"
            gutterBottom
            sx={titleStyle}
          >
            <LocationOnIcon aria-hidden="true" />
            כתובת
          </Typography>

          <Typography
            component="p"
            variant="body1"
            sx={{ mb: 2 }}
          >
            מאה שערים 7, ירושלים - ישראל
          </Typography>

          <Typography
            component="h2"
            variant="h6"
            gutterBottom
            sx={titleStyle}
          >
            <PhoneIcon aria-hidden="true" />
            טלפון
          </Typography>

          <Typography
            component="p"
            variant="body1"
            dir="ltr"
            sx={{
              mb: 2,
              textAlign: "right",
            }}
          >
            02-5853000
          </Typography>

          <Typography
            component="h2"
            variant="h6"
            gutterBottom
            sx={titleStyle}
          >
            <AccessTimeIcon aria-hidden="true" />
            שעות פעילות
          </Typography>

          <Typography
            component="p"
            variant="body1"
          >
            א׳–ה׳ 9:00–21:00
            <br />
            יום ו׳ 9:00–13:00
          </Typography>
        </Grid>

        {/* אודות */}
        <Grid item xs={12} sm={3}>
          <Typography
            component="h2"
            variant="h6"
            gutterBottom
          >
            <Link
              component={RouterLink}
              to="/about"
              underline="none"
              sx={accessibleLinkStyle}
            >
              אודות
            </Link>
          </Typography>

          <Typography
            component="p"
            variant="subtitle1"
            color="text.secondary"
          >
            מידע עלינו ועל החברה.
          </Typography>
        </Grid>

        {/* צור קשר */}
        <Grid item xs={12} sm={3}>
          <Typography
            component="h2"
            variant="h6"
            gutterBottom
          >
            <Link
              component={RouterLink}
              to="/contact"
              underline="none"
              sx={accessibleLinkStyle}
            >
              צור קשר
            </Link>
          </Typography>

          <Typography
            component="p"
            variant="subtitle1"
            color="text.secondary"
          >
            שליחת פנייה
          </Typography>
        </Grid>

        {/* תקנונים */}
        <Grid item xs={12} sm={3}>
          <Typography
            component="h2"
            variant="h6"
            gutterBottom
          >
            <Link
              component={RouterLink}
              to="/conditions"
              underline="none"
              sx={accessibleLinkStyle}
            >
              תנאי שימוש
            </Link>
          </Typography>

          <Typography
            component="p"
            variant="subtitle1"
            color="text.secondary"
            sx={{ mb: 2 }}
          >
            התנאים וההגבלות לשימוש באתר.
          </Typography>

          <Typography
            component="h2"
            variant="h6"
            gutterBottom
          >
            <Link
              component={RouterLink}
              to="/shipping-policy"
              underline="none"
              sx={accessibleLinkStyle}
            >
              תקנון משלוחים
            </Link>
          </Typography>

          <Typography
            component="p"
            variant="subtitle1"
            color="text.secondary"
          >
            מדיניות המשלוחים של האתר.
          </Typography>
          <Typography
            component="h2"
            variant="h6"
            gutterBottom
            sx={{ mt: 2 }}
          >
            <Link
              component={RouterLink}
              to="/accessibility-statement"
              underline="none"
              sx={accessibleLinkStyle}
            >
              הצהרת נגישות
            </Link>
          </Typography>

          <Typography
            component="p"
            variant="subtitle1"
            color="text.secondary"
          >
            מידע על התאמות הנגישות באתר.
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}